import { useEditorState } from '@tiptap/react'
import { type VFC } from 'react'
import { Size } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import { Button, ButtonIconPosition, Icon } from '@opallabs/lapidary'
import { useTextEditor } from '../../../TextEditor'
import { useEditorVisibility } from '../../../TextEditor/hooks'
import * as styles from './styles'

export const CLASSNAME = 'texteditor-versioning-modal-toggle'

type OpenVersionsButtonProps = Readonly<{
  alwaysVisible?: boolean
  isFullScreen: boolean
  onClick: () => void
}>

export const OpenVersionsButton: VFC<OpenVersionsButtonProps> = ({
  alwaysVisible = false,
  isFullScreen,
  onClick,
}) => {
  const theme = useTheme()
  const { editor } = useTextEditor()
  const viewOnly = useEditorState({
    editor,
    selector: (snapshot) => !snapshot.editor.isEditable,
  })
  const isVisible = useEditorVisibility({
    alwaysVisible,
    visibleOn: isFullScreen,
  })

  return (
    <Button
      buttonText="Version History"
      className={CLASSNAME}
      css={styles.versionModalToggle({ isVisible, theme, viewOnly })}
      iconPosition={ButtonIconPosition.leading}
      icon={
        <Icon
          glyph="gem-version-history"
          width={Size.Icon + 2.5}
          height={Size.Icon + 2.5}
          ariaHidden
        />
      }
      name="versioning"
      onClick={onClick}
      variant="ghost"
    />
  )
}
